import React, { Component, useState } from "react";
import Header from "../components/header";

const Admin = (props) => {
  return (
    <div style={{ position: "relative", minHeight: "100vh" }}>
      <Header
        texts={props.texts}
        globalState={props.globalState}
        langHandler={props.langHandler}
      />
      <div
        className="w-100 d-flex justify-content-center"
        style={{ position: "absolute", top: 135 }}
      >
        <div className="text-center rug-tab-div"></div>
      </div>
    </div>
  );
};

export default Admin;
